import React from 'react';
import './ContentUserManagementDetails.css';
import ContentUserManagementDetails from './ContentUserManagement/ContentUserManagementDetails';
import ContentUserManagementDetailsNew from './ContentUserManagement/ContentUserManagementDetailsNew';
import ContentAddNewUser from './ContentAddNewUser';


function ContentUserManagement() {

  return (
    <>
        <section className='ContentUserManagement'>

            {/* <ContentUserManagementDetails /> */}
            <ContentUserManagementDetailsNew />
            {/* <ContentAddNewUser /> */}

        </section>
    </>
  );
}

export default ContentUserManagement;
